export const useToken = () => {
  const token = useCookie<string>('token')
  if (token && token.value !== null && token.value !== '') {
    return token.value
  }
  return null
}